export const EVENT_TYPES = [
    { key: "LEISURE", value: "LEISURE", text: "misc:event_types.leisure" },
    { key: "PROFESSIONAL", value: "PROFESSIONAL", text: "misc:event_types.professional" },
    { key: "FAST", value: "FAST", text: "misc:event_types.fast" },
    { key: "BIRTHDAY", value: "BIRTHDAY", text: "misc:event_types.birthday" },
    { key: "SPECIAL", value: "SPECIAL", text: "misc:event_types.special" },
    { key: "OTHER", value: "OTHER", text: "misc:event_types.other" },
];


// Values are not used as key because i18n does not like keys with ':'. 
export const CAKE_BEFORE_DURATION_LIST = [
    { value: "1 00:00:00", text: "reservation_page.options_form.1_day_before" },
    { value: "2 00:00:00", text: "reservation_page.options_form.2_days_before" },
    { value: "3 00:00:00", text: "reservation_page.options_form.3_days_before" },
    { value: "4 00:00:00", text: "reservation_page.options_form.4_days_before" },
    { value: "5 00:00:00", text: "reservation_page.options_form.5_days_before" },
    { value: "6 00:00:00", text: "reservation_page.options_form.6_days_before" },
];

// Value can be used as translation keys with settings: reservation_before_duration_options
export const RESERVATION_BEFORE_DURATION_OPTIONS = [
    { value: "00:00:00", text: "settings:reservation_before_duration_options.0_min" },
    { value: "00:05:00", text: "settings:reservation_before_duration_options.5_min" },
    { value: "00:15:00", text: "settings:reservation_before_duration_options.15_min" },
    { value: "00:30:00", text: "settings:reservation_before_duration_options.30_min" },
    { value: "01:00:00", text: "settings:reservation_before_duration_options.1_hour" },
    { value: "02:00:00", text: "settings:reservation_before_duration_options.2_hours" },
    { value: "03:00:00", text: "settings:reservation_before_duration_options.3_hours" },
    { value: "06:00:00", text: "settings:reservation_before_duration_options.6_hours" },
    { value: "12:00:00", text: "settings:reservation_before_duration_options.12_hours" },
    { value: "1 00:00:00", text: "settings:reservation_before_duration_options.1_day" },
    { value: "2 00:00:00", text: "settings:reservation_before_duration_options.2_days" },
];





export const CANCELLED_BY_LIST = [
    { key: "CANCELLED_BY_RESTAURANT", value: "CANCELLED_BY_RESTAURANT", text: "reservations_history:cancelled_by.restaurant" },
    { key: "CANCELLED_BY_CUSTOMER", value: "CANCELLED_BY_CUSTOMER", text: "reservations_history:cancelled_by.customer" },
];

export const weekDaysOptions = [
    { key: 0, text: "common:weekdays.monday", value: 0 },
    { key: 1, text: "common:weekdays.tuesday", value: 1 },
    { key: 2, text: "common:weekdays.wednesday", value: 2 },
    { key: 3, text: "common:weekdays.thursday", value: 3 },
    { key: 4, text: "common:weekdays.friday", value: 4 },
    { key: 5, text: "common:weekdays.saturday", value: 5 },
    { key: 6, text: "common:weekdays.sunday", value: 6 },
];
export const WEEK_DAYS_OPTIONS = [
    { value: 0, text: "common:weekdays.monday" },
    { value: 1, text: "common:weekdays.tuesday" },
    { value: 2, text: "common:weekdays.wednesday" },
    { value: 3, text: "common:weekdays.thursday" },
    { value: 4, text: "common:weekdays.friday" },
    { value: 5, text: "common:weekdays.saturday" },
    { value: 6, text: "common:weekdays.sunday" },
];


export const CONFIRMATION_MODE = Object.freeze({
    CONFIRMATION_MODE_ASYNCHRONOUS: "CONFIRMATION_MODE_ASYNCHRONOUS",
    CONFIRMATION_MODE_SYNCHRONOUS: "CONFIRMATION_MODE_SYNCHRONOUS",
});

export const RESERVATION_STATUS = Object.freeze({
    PENDING: "PENDING",
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
    ARCHIVED: "ARCHIVED",
});

export const RESERVATION_CANCELLED_BY_CHOICES = Object.freeze({
    CANCELLED_BY_RESTAURANT: "CANCELLED_BY_RESTAURANT",
    CANCELLED_BY_CUSTOMER: "CANCELLED_BY_CUSTOMER",
})


// WEBPACK FOOTER //
// ./src/constants/reservations.js